module.exports = __webpack_public_path__ + "static/media/025.dd9790a2.jpg";